var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBasket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.722 0 1.356.116 1.908.318a4.5 4.5 0 0 1 1.213.67 4.5 4.5 0 0 1 .89.928 5 5 0 0 1 .561 1.01A5.5 5.5 0 0 1 17 7v1h5v2h-1.08l-.924 11.083A1 1 0 0 1 19 22H5a1 1 0 0 1-.996-.917L3.08 10H2V8h5V7q0-.155.012-.327a5.6 5.6 0 0 1 .607-2.157 5 5 0 0 1 .689-.995 4.45 4.45 0 0 1 1.784-1.203A5.5 5.5 0 0 1 12 2m4 8H5.087l.833 10h12.16l.833-10zm-4-6c-.557 0-1.005.097-1.366.255a2.46 2.46 0 0 0-1.023.829 3 3 0 0 0-.286.493A3.6 3.6 0 0 0 9 7v1h6V7q0-.191-.032-.425a3.6 3.6 0 0 0-.293-.998 3 3 0 0 0-.286-.493 2.5 2.5 0 0 0-1.023-.83C13.005 4.098 12.557 4 12 4"
  })));
};
export default SvgShoppingBasket;